import type { EndpointMeta } from "@/apis/types";
import {
  createFetchAndHook,
  type FetchFactory,
  type HookFactory,
} from "@/shared/factories";
import { wsfTerminalsApiMeta } from "../apiMeta";
import {
  type TerminalVerboseInput,
  terminalVerboseInputSchema,
} from "./shared/terminalVerbose.input";
import {
  type TerminalVerbose,
  terminalVerboseSchema,
} from "./shared/terminalVerbose.output";

/**
 * Metadata for the fetchTerminalVerbose endpoint
 */
export const terminalVerboseMeta = {
  functionName: "fetchTerminalVerbose",
  endpoint: "/terminalVerbose",
  inputSchema: terminalVerboseInputSchema,
  outputSchema: terminalVerboseSchema.array(),
  sampleParams: {},
  endpointDescription: "List comprehensive information for all terminals.",
} satisfies EndpointMeta<TerminalVerboseInput, TerminalVerbose[]>;

/**
 * Fetch function for retrieving comprehensive information for all terminals
 */
const { fetch, useHook } = createFetchAndHook<
  TerminalVerboseInput,
  TerminalVerbose[]
>({
  api: wsfTerminalsApiMeta,
  endpoint: terminalVerboseMeta,
  getCacheStrategy: () =>
    // eslint-disable-next-line @typescript-eslint/no-var-requires
    require("./shared/terminalVerbose.endpoints").terminalVerboseGroup
      .cacheStrategy,
});

/**
 * Fetch function for retrieving comprehensive information for all terminals
 */
export const fetchTerminalVerbose: FetchFactory<
  TerminalVerboseInput,
  TerminalVerbose[]
> = fetch;

/**
 * React Query hook for retrieving comprehensive information for all terminals
 */
export const useTerminalVerbose: HookFactory<
  TerminalVerboseInput,
  TerminalVerbose[]
> = useHook;
